import { Button, message } from 'ui';
import { useMarkAsRead } from '../queries';

type P = {
  postId: string;
  status: string;
  view: 'bookmark' | 'other';
};

const MarkAsRead = ({ postId, status, view }: P) => {
  const { isPending: isLoadingMarkAsCompleted, mutate: markAsRead } = useMarkAsRead();

  const isDisabled = status === 'read' || view === 'bookmark';

  return (
    <Button
      disabled={isDisabled}
      loading={isLoadingMarkAsCompleted}
      onClick={() => {
        markAsRead(
          { postId },
          {
            onError() {
              message.error('Failed to mark post as read');
            },
            onSuccess() {
              message.success('Post marked as read successfully');
            },
          },
        );
      }}
      size="large"
      type="primary"
    >
      {status === 'read' ? 'Marked as read' : 'Mark as read'}
    </Button>
  );
};

export default MarkAsRead;
